'use client'

import { useRef } from 'react'

import { useServerInsertedHTML } from 'next/navigation'

// Emit the native controller only into the initial HTML stream. Rendering an
// inline script in the route tree leaves an inert script on client navigation.
export const PublicStylesBootstrap = ({ source }: { source: string }) => {
  const inserted = useRef(false)

  useServerInsertedHTML(() => {
    if (inserted.current) {
      return null
    }
    inserted.current = true
    return <script dangerouslySetInnerHTML={{ __html: source }} />
  })

  return null
}
